import axios from 'axios';
import { getApiBaseUrl } from '../services/utils/apiConfig';

const axiosClient = axios.create({
  baseURL: getApiBaseUrl(), // 유틸리티 함수 사용
  timeout: 60000, // 60초로 증가 (로그인 등 중요한 작업을 위해)
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('adminToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    if (config.data instanceof FormData) {
      delete config.headers['Content-Type'];
    }
    
    return config;
  },
  (error) => Promise.reject(error)
);

// 응답 인터셉터
axiosClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('adminTokenExpiration');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axiosClient;
